import { createSlice } from "@reduxjs/toolkit";
import { allCustomerAPI } from "../../api/customer";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const allCustomerSlice = createSlice({
  name: "allCustomer",
  initialState: data,
  reducers: {
    allCustomerSlice(state) {
      state.isLoading = true;
    },
    allCustomerSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    allCustomerSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    allCustomerSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const allCustomerHandler: any = () => async (dispatch: any) => {
  try {
    dispatch(allCustomerAction.allCustomerSlice());
    const response: any = await allCustomerAPI();

    dispatch(allCustomerAction.allCustomerSliceSuccess(response));
  } catch (e: any) {
    dispatch(allCustomerAction.allCustomerSliceFailure(e?.response?.data));
  }
};
export default allCustomerSlice.reducer;
export const allCustomerAction = allCustomerSlice.actions;
